<div class="speed-normatives">
  <div class="mt-24">
    <div class="filter pos-r">
      <app-loader *ngIf="isFiltersLoading"></app-loader>
      <div class="panel">
        <div class="panel__content">
          <!-- Панель фильтра -->
          <div class="grid">
            <div class="grid__box grid__box--size-3">
              <div class="text-title mb-8">Регион</div>
              <div class="field field--select">
                <app-select [items]="regions" [initBy]="selectedRegion" [textKey]="'name'" [defaultText]="'Выберите регион'" (callback)="onChangeRegion($event)"></app-select>
              </div>
            </div>
            <div class="grid__box grid__box--size-3">
              <div class="text-title mb-8">Филиал</div>
              <div class="field field--select">
                <app-select
                  [items]="branches"
                  [initBy]="selectedBranch"
                  [textKey]="'mb_name'"
                  [defaultText]="selectedRegion ? 'Выберите филиал' : 'Выберите регион'"
                  [isDisabled]="branches.length === 0"
                  (callback)="onChangeBranch($event)"
                ></app-select>
              </div>
            </div>
            <div class="grid__box grid__box--size-3">
              <div class="text-title mb-8">Участок</div>
              <div class="field field--select">
                <app-select
                  [items]="sectors"
                  [initBy]="selectedSector"
                  [textKey]="'sector_number_str'"
                  [defaultText]="!selectedRegion ? 'Выберите регион' : !selectedBranch ? 'Выберите филиал' : 'Выберите участок'"
                  [isDisabled]="sectors.length === 0"
                  (callback)="onChangeSector($event)"
                ></app-select>
              </div>
            </div>
            <div class="grid__box grid__box--size-3">
              <div class="text-title mb-8">Средство передвижения</div>
              <div class="field field--select">
                <app-select
                  [items]="vehicleTypes"
                  [initBy]="selectedVehicleType"
                  [textKey]="'name'"
                  [defaultText]="'Выберите средство передвижения'"
                  [nullChoice]="true"
                  [isDisabled]="vehicleTypes.length === 0"
                  (callback)="onChangeVehicleType($event)"
                ></app-select>
              </div>
            </div>
            <div class="align-end grid__box grid__box--size-min mt-16">
              <div class="grid grid--va-middle">
                <div class="grid__box grid__box--size-min">
                  <button type="button" class="button button--primary" (click)="applyFilter()">Применить</button>
                </div>
                <div class="grid__box grid__box--size-min">
                  <a id="appResetSpeedNormativesFilter" class="link link--dotted-blue-dark" (click)="resetFilter()">Сбросить</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <h2 class="title title--big mt-32">{{ getScopeTitle() }}</h2>

  <div class="speed-normatives__loader padding-24 pos-r" *ngIf="isLoading">
    <app-loader></app-loader>
  </div>

  <app-message [type]="'error'" *ngIf="error && !isLoading">
    <div message-content>
      {{ error }}
      <a class="link link--dotted-blue-dark ml-8" (click)="loadStandards()">Повторить</a>
    </div>
  </app-message>

  <ng-container *ngIf="!isLoading && !error">
    <app-message [type]="'error'" [size]="'small'" *ngIf="saveError">
      <div message-content>{{ saveError }}</div>
    </app-message>

    <app-message [type]="'success'" [size]="'small'" *ngIf="successMessage && !saveError">
      <div message-content>{{ successMessage }}</div>
    </app-message>

    <div class="speed-normatives__hint mt-8">Наведите на ячейку с нормативом, чтобы отредактировать</div>

    <div class="speed-normatives__table mt-8">
      <table class="tbl tbl--full">
        <thead>
          <tr>
            <th>Участок</th>
            <th>Средство передвижения</th>
            <th>Норматив скорости, км/ч</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of rows">
            <td>{{ getSectorName(row.sectorId) }}</td>
            <td>{{ row.vehicleTypeName }}</td>
            <td class="speed-normatives__value-cell">
              <div class="speed-normatives__cell-view" *ngIf="!row.isEditing">
                <span>{{ formatValue(row.value) }}</span>
                <button type="button" class="ctrl speed-normatives__edit-btn" [disabled]="row.isSaving" (click)="startEditing(row)">✏️</button>
              </div>

              <div class="speed-normatives__cell-edit" *ngIf="row.isEditing">
                <input
                  type="number"
                  min="0"
                  class="input-text speed-normatives__input"
                  [value]="row.value"
                  [disabled]="row.isSaving"
                  (input)="onValueInput(row, $event.target.value)"
                  (keyup.enter)="saveRow(row)"
                  (keyup.escape)="cancelEditing(row)"
                />
                <button type="button" class="ctrl speed-normatives__action-btn" [disabled]="row.isSaving" (click)="saveRow(row)">✔️</button>
                <button type="button" class="ctrl speed-normatives__action-btn" [disabled]="row.isSaving" (click)="cancelEditing(row)">❌</button>
              </div>
            </td>
          </tr>
          <tr *ngIf="rows.length === 0">
            <td colspan="3" class="ta-center">Нет данных</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-container>
</div>
